import React, { memo } from "react";

const IconAlignTop = ({ color = "#3699FF", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    {...props}
    width="20"
    fill={color}
  >
    <path
      stroke={color}
      d="M192-744v-72h576v72H192Zm252 600v-390L339-429l-51-51 192-192 192 192-51 51-105-105v390h-72Z"
    />
  </svg>
);

export default memo(IconAlignTop);
